import { axios } from "../connection/ConnectionHandler";
import { FETCH_REPCON } from "../constants";
import { API } from "../constants/api";
import { createCrudActions } from "../utils/crudGenerator";

const formatMachines = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.name}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchMachines,
  create: createMachine,
  update: updateMachine,
  delete: deleteMachines,
} = createCrudActions("MACHINE", "Maquina", formatMachines);

export const fetchRepcon = () => async (dispatch) => {
  try {
    const response = await axios.get(API.machines.repcon);
    if (response.status === 200 && response.data) {
      dispatch({ type: FETCH_REPCON, payload: response.data });
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
};
